import type { VenueDetailsType } from '@api';
import {
  AddressCell,
  Anchor,
  TouringCard,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTable,
  TouringCardTableBody,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
  TouringCardTitle,
  VenueAnchor,
} from '@common';
import { useTranslation } from 'react-i18next';

const TRANS_KEY = 'COMPANY_VENUES.ROWS';

type CompanyVenueViewPropsType = {
  venue: VenueDetailsType;
};

export const CompanyVenueView: React.FC<CompanyVenueViewPropsType> = ({
  venue,
}) => {
  const { t } = useTranslation('companyDetailsVenues');
  const { t: tVenues } = useTranslation('venues');

  return (
    <TouringCard data-testid={`company-venues-card-${venue.id}`}>
      <TouringCardHeader>
        <TouringCardTitle>
          <VenueAnchor venue={venue} />
        </TouringCardTitle>
      </TouringCardHeader>
      <TouringCardSection>
        <TouringCardTable>
          <TouringCardTableBody>
            <TouringCardTableRow>
              <TouringCardTableRowLabel>
                {t(`${TRANS_KEY}.SHORTNAME`)}
              </TouringCardTableRowLabel>
              <TouringCardTableRowValue>{venue.shortName}</TouringCardTableRowValue>
            </TouringCardTableRow>
            <TouringCardTableRow>
              <TouringCardTableRowLabel>
                {t(`${TRANS_KEY}.CATEGORY`)}
              </TouringCardTableRowLabel>
              <TouringCardTableRowValue>
                {tVenues(`CATEGORIES.${venue.category}`)}
              </TouringCardTableRowValue>
            </TouringCardTableRow>
            <TouringCardTableRow>
              <TouringCardTableRowLabel>
                {t(`${TRANS_KEY}.WEBSITE`)}
              </TouringCardTableRowLabel>
              <TouringCardTableRowValue>
                <Anchor to={venue.website} target="_blank">
                  {venue.website}
                </Anchor>
              </TouringCardTableRowValue>
            </TouringCardTableRow>
            <TouringCardTableRow>
              <TouringCardTableRowLabel>
                {t(`${TRANS_KEY}.ADDRESS`)}
              </TouringCardTableRowLabel>
              <TouringCardTableRowValue>
                <AddressCell address={venue.address} />
              </TouringCardTableRowValue>
            </TouringCardTableRow>
          </TouringCardTableBody>
        </TouringCardTable>
      </TouringCardSection>
    </TouringCard>
  );
};
